import c0 from './autosize_controller';
import c1 from './cable-ready_controller';
import c2 from './clipboard_controller';
import c3 from './disabler_controller';
import c4 from './file_controller';
import c5 from './fill_controller';
import c6 from './filter_controller';
import c7 from './form_controller';
import c8 from './global_search_controller';
import c9 from './keyword_controller';
import c10 from './maths_controller';
import c11 from './modal_controller';
import c12 from './navbar_controller';
import c13 from './nested_controller';
import c14 from './pick_controller';
import c15 from './previous_controller';
import c16 from './reload_controller';
import c17 from './report_controller';
import c18 from './return_controller';
import c19 from './search_controller';
import c20 from './shop_return_controller';
import c21 from './shop_subscription_controller';
import c22 from './stripe_controller';
import c23 from './subscription_controller';
import c24 from './tabs_controller';
import c25 from './toggler_controller';
import c26 from './voucher_controller';
import c27 from './xor_controller';
export const definitions = [
	{identifier: 'autosize', controllerConstructor: c0},
	{identifier: 'cable-ready', controllerConstructor: c1},
	{identifier: 'clipboard', controllerConstructor: c2},
	{identifier: 'disabler', controllerConstructor: c3},
	{identifier: 'file', controllerConstructor: c4},
	{identifier: 'fill', controllerConstructor: c5},
	{identifier: 'filter', controllerConstructor: c6},
	{identifier: 'form', controllerConstructor: c7},
	{identifier: 'global-search', controllerConstructor: c8},
	{identifier: 'keyword', controllerConstructor: c9},
	{identifier: 'maths', controllerConstructor: c10},
	{identifier: 'modal', controllerConstructor: c11},
	{identifier: 'navbar', controllerConstructor: c12},
	{identifier: 'nested', controllerConstructor: c13},
	{identifier: 'pick', controllerConstructor: c14},
	{identifier: 'previous', controllerConstructor: c15},
	{identifier: 'reload', controllerConstructor: c16},
	{identifier: 'report', controllerConstructor: c17},
	{identifier: 'return', controllerConstructor: c18},
	{identifier: 'search', controllerConstructor: c19},
	{identifier: 'shop-return', controllerConstructor: c20},
	{identifier: 'shop-subscription', controllerConstructor: c21},
	{identifier: 'stripe', controllerConstructor: c22},
	{identifier: 'subscription', controllerConstructor: c23},
	{identifier: 'tabs', controllerConstructor: c24},
	{identifier: 'toggler', controllerConstructor: c25},
	{identifier: 'voucher', controllerConstructor: c26},
	{identifier: 'xor', controllerConstructor: c27},
];
